<script lang="ts">
    import {Link} from 'svelte-routing'
    import {getArticlesByFilter} from 'src/components/main/#services/blogArticles'
    import {dateFormat} from 'src/global/dateFormat'

    export let articleId
    export let categoryId
    export let limit

    $: {
        getArticlesByFilter.reset()
        getArticlesByFilter.send({ data: {articleId, categoryId, limit }})
    }
</script>

<div class="blog">
    <div class="section-title">Related articles</div>
    <div class="row blog-cards">
        {#if !$getArticlesByFilter.hasValue && $getArticlesByFilter.loading}
            <div class="color-white">Loading...</div>
        {:else if !$getArticlesByFilter.hasValue && $getArticlesByFilter.error }
            <div class="color-white">Something went wrong. Try refreshing the page.</div>
        {:else if $getArticlesByFilter.value}
            {#each $getArticlesByFilter.value.data as { title, image, url, createdAt, shortDescription }}
                <div class="col-md-4">
                    <Link to="blog/{url}" class="blog-card">
                        <div class="image">
                            <img src="{process.env.IMAGES_PATH}{image}" alt="">
                        </div>
                        <div class="date">{dateFormat(createdAt, 'full')}</div>
                        <div class="title">{title}</div>
                        <div class="description">{shortDescription}</div>
                    </Link>
                </div>
            {/each}
        {/if}
    </div>
</div>

<style>
    .blog {
        margin: 30px 0;
    }

    :global(.blog-card) {
        text-decoration: none;
        margin-bottom: 30px;
        display: block;
    }

    .section-title {
        font-family: 'Anton', sans-serif;
        font-size: 50px;
        font-weight: 400;
        color: white;
        margin: 0 0 30px;
        line-height: 1.5;
        text-transform: uppercase;
        letter-spacing: 0.02em;
    }

    .section-title span {
        color: transparent;
        -webkit-text-stroke: 1px white;
    }

    .blog-cards {
        margin: 0 -20px 10px;
    }

    .date {
        color: #505a65;
        font-size: 13px;
        margin: 20px 0 10px;
    }

    .title {
        font-size: 25px;
        line-height: 1.5;
        font-family: 'Anton', sans-serif;
        color: white;
        letter-spacing: 0.04em;
        margin-bottom: 20px;
    }

    .description {
        font-size: 16px;
        line-height: 1.6;
        color: #A0AEC0;
    }

    .blog :global(.blog-card) {
        position: relative;
        padding: 0 8px;
        margin-bottom: 40px;
        display: block;
    }

    .blog :global(.blog-card:hover:before) {
        border-color: #FE4900;
    }

    .blog :global(.blog-card:hover .title) {
        text-decoration: underline;
    }

    .image {
        overflow: hidden;
        height: 250px;
    }

    .image img {
        max-width: 100%;
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
        transition: .25s;
    }

    .blog :global(.blog-card:hover .image img) {
        transform: scale(1.2) rotate(7deg);
    }

    .show-all-btn {
        font-size: 20px;
        letter-spacing: 0.04em;
        position: absolute;
        top: 0;
        right: 0;
        padding-left: 15px;
        cursor: pointer;
    }

    .show-all-btn img {
        margin-left: 10px;
        transition: .25s;
    }

    .show-all-btn:hover img {
        transform: rotate(45deg);
    }

    @media(max-width: 1400px) {
        .image {
            height: 230px;
        }

        .description {
            font-size: 14px;
        }
    }

    @media(max-width: 1199px) {
        .section-title {
            font-size: 50px;
            line-height: 70px;
        }

        .image {
            height: 200px;
        }

        .title {
            font-size: 22px;
        }
    }

    @media(max-width: 991px) {
        .date {
            color: #7e8893;
            font-size: 12px;
        }

        .description {
            font-size: 12px;
            margin-bottom: 20px;
        }

        .image {
            height: 160px;
        }

        .title {
            font-size: 18px;
            margin-bottom: 12px;
        }

        .blog :global(.blog-card) {
            padding: 0;
            margin-bottom: 30px;
        }

        .blog-cards {
            margin: 0 -12px 10px;
        }
    }

    @media(max-width: 767px) {
        .section-title {
            font-size: 40px;
            line-height: 52px;
        }

        .blog :global(.blog-card) {
            padding: 0 162px 0 0;
            margin-bottom: 30px;
            min-height: 90px;
        }

        .image {
            height: 90px;
            width: 150px;
            position: absolute;
            right: 0;
            top: 0;
        }

        .date {
            color: #A0AEC0;
            margin-top: 0;
        }

        .title {
            margin-bottom: 0;
        }

        .description {
            display: none;
        }
    }
</style>
